import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import APICaller from "../../utils/APICaller";
import { decrypt } from "../../utils/Constants";
import { createDynamicThunk } from ".";
import { clearRedux } from "../slices/authSlice";
import { jwtDecode } from "jwt-decode";

export const validateAndLoginThunk = createAsyncThunk(
  "auth/validateAndLogin",
  async ({ auth }, { rejectWithValue }) => {
    try {
      /* =========================
       * DEVICE INFO
       * ========================= */
      let deviceInfo = {};
      try {
        const response = await axios.get(process.env.REACT_APP_IPIFY);
        deviceInfo = {
          userAgent: navigator.userAgent,
          screenWidth: window.innerWidth,
          screenHeight: window.innerHeight,
          ip: response?.data?.ip,
        };
      } catch {
        deviceInfo = {};
      }

      /* =========================
       * VALIDATE TOKEN
       * ========================= */
      const validateResponse = await APICaller("", "", "/login", "POST", {
        auth,
        device: deviceInfo,
      });

      if (!validateResponse || validateResponse.statusCode !== 200) {
        return rejectWithValue("Login failed");
      }

      /* ========================================
       * DECRYPT RESPONSE (ONLY AFTER SUCCESS)
       * ======================================== */
      if (!validateResponse.respnse) {
        return rejectWithValue("Encrypted response missing");
      }
      const decryptedData = decrypt(
        validateResponse.respnse,
        process.env.REACT_APP_SSO_ENCRYPTION_KEY,
      );

     
      if (!decryptedData) {
        return rejectWithValue("Decryption failed");
      }
      const decryptedObject = JSON.parse(decryptedData);

      const user = decryptedObject?.user;
      const accessToken = decryptedObject?.accessToken;
     // const expiryTime = decryptedObject?.expiryTime;
      const extraData = decryptedObject?.decryptedData;
      const access = decryptedObject?.access;
      if (!user || !user.empID) {
        return rejectWithValue("Invalid user data from token");
      }

      // ✅ Decode expiry from JWT
      const decoded = jwtDecode(accessToken);
      const expiryTime = decoded.exp * 1000;


      /* =========================
       * RETURN FINAL USER
       * ========================= */
      return {
        isLoggedIn: true,
        accessToken,
        accessTokenExpiresOn: expiryTime,
        user,
        extraData,
        access
      };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const validateAndLoginThunk1 = createAsyncThunk(
  "auth/validateAndLogin",
  async ({ token }, { rejectWithValue }) => {
    try {
      /* =========================
       * DEVICE INFO
       * ========================= */
      let deviceInfo = {};
      try {
        const response = await axios.get(process.env.REACT_APP_IPIFY);
        deviceInfo = {
          userAgent: navigator.userAgent,
          screenWidth: window.innerWidth,
          screenHeight: window.innerHeight,
          ip: response?.data?.ip,
        };
      } catch {
        deviceInfo = {};
      }

      /* =========================
       * VALIDATE TOKEN
       * ========================= */
      const validateResponse = await APICaller(
        "",
        token,
        "/validateToken",
        "POST",
        {
          auth: token,
          device: deviceInfo,
        },
      );

      if (!validateResponse || validateResponse.statusCode !== 200) {
        return rejectWithValue("Token validation failed");
      }

      /* ========================================
       * DECRYPT RESPONSE (ONLY AFTER SUCCESS)
       * ======================================== */
      if (!validateResponse.respnse) {
        return rejectWithValue("Encrypted response missing");
      }
      const decryptedData = decrypt(
        validateResponse.respnse,
        process.env.REACT_APP_SSO_ENCRYPTION_KEY,
      );

      if (!decryptedData) {
        return rejectWithValue("Decryption failed");
      }
      const decryptedObject = JSON.parse(decryptedData);

      const user = decryptedObject?.user;
      const accessToken = decryptedObject?.accessToken;
      const expiryTime = decryptedObject?.expiryTime;
      const extraData = decryptedObject?.decryptedData;

      if (!user || !user.empID) {
        return rejectWithValue("Invalid user data from token");
      }

      /* =========================
       * RETURN FINAL USER
       * ========================= */
      return {
        isLoggedIn: true,
        accessToken,
        accessTokenExpiresOn: expiryTime,
        user,
        extraData,
      };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const checkUserStatusThunk = createDynamicThunk({
  typePrefix: "checkUserStatusThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

export const userUpdateThunk = createDynamicThunk({
  typePrefix: "userUpdateThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

// export const emailVerificationThunk = createDynamicThunk({
//   typePrefix: "emailVerificationThunk",
//   endpoint: "/emailVerification",
//   method: "POST",
// });

//Signout Thunk
export const signoutThunk = createAsyncThunk(
  "auth/signOut",
  async (
    { role, lIUId, token, accessTokenExpiresOn },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const endpoint = "/fetchWithoutPagination";
      const method = "POST";
      const payload = {
        route: "users",
        action: "upLoggedIn",
        lIUId
      };

      const response = await APICaller(
        role,
        token,
        endpoint,
        method,
        payload,
        accessTokenExpiresOn,
      );

      if (!response || response.statusCode !== 200) {
        return rejectWithValue(response?.message || "Sign out failed");
      }

      // Return whatever backend sends (optional)
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);
